import { m } from '@pricedrop/i18n';
import BellRing from 'lucide-react/dist/esm/icons/bell-ring';
import { useState } from 'react';
import { ItemNotificationDialog } from '@/components/notifications';
import { Button } from '@/components/ui/button';
import { useSession } from '@/lib/auth-client';
import { useAuthModal } from '@/lib/auth-modal-context';
import { useTagsNotification } from '@/lib/notifications';

interface TagsNotificationButtonProps {
  tags: number[];
  tagNames: string[];
  brandIds?: number[] | null;
  brandNames?: string[] | null;
}

export function TagsNotificationButton({
  tags,
  tagNames,
  brandIds,
  brandNames,
}: TagsNotificationButtonProps) {
  const { data: session } = useSession();
  const { requireAuth } = useAuthModal();
  const [dialogOpen, setDialogOpen] = useState(false);

  const { data: existingNotification } = useTagsNotification(tags, brandIds ?? null, !!session);

  const handleClick = () => {
    requireAuth(() => setDialogOpen(true), {
      title: m.notifications_auth_title(),
      description: m.notifications_auth_description(),
    });
  };

  const buttonText = existingNotification
    ? m.notifications_tags_bell_update()
    : m.notifications_tags_bell_create();

  return (
    <>
      <Button
        onClick={handleClick}
        variant="outline"
        size="sm"
        className="flex h-8 items-center gap-1.5 px-2 sm:px-3"
      >
        <BellRing className="h-3.5 w-3.5" />
        <span className="hidden text-xs sm:inline">{buttonText}</span>
      </Button>

      <ItemNotificationDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        itemUin={0}
        itemName=""
        currentPrice={null}
        scope="TAGS"
        tags={tags}
        tagNames={tagNames}
        brandIds={brandIds}
        brandNames={brandNames}
        existingNotification={existingNotification}
      />
    </>
  );
}
